<div *ngIf="!selectedPlan">
  <div class="pricing-shell">
    <div class="pricing-grid">
      <article
        *ngFor="let plan of pricingCards"
        class="pricing-card"
        [ngClass]="{
          'pricing-card--recommended': plan.recommended,
          'pricing-card--enterprise': plan.enterprise
        }"
      >
        <div *ngIf="plan.recommended" class="pricing-badge">Recommended</div>

        <div class="pricing-card__header">
          <h2 class="pricing-card__title">{{ plan.title }}</h2>
          <p class="pricing-card__subtitle">{{ plan.subtitle }}</p>
        </div>

        <div class="pricing-card__deposit">
          <span class="deposit-label">{{ plan.depositLabel }}</span>
          <div class="deposit-amount">{{ plan.depositAmount }}</div>
          <p class="deposit-support">{{ plan.depositSupport }}</p>
          <div
            class="pricing-card__callout"
            [class.pricing-card__callout--active]="plan.enterprise"
          >
            <span *ngIf="plan.enterprise">Volume discounts available</span>
          </div>
        </div>

        <button type="button" class="pricing-cta" (click)="planClick(plan.planId)">GET ACCESS</button>
        <div class="pricing-card__cta-divider" aria-hidden="true"></div>

        <div *ngIf="!plan.enterprise; else enterpriseSensorSummary" class="pricing-accordion" [class.is-open]="isPricingAccordionOpen(plan.planId)">
          <button
            type="button"
            class="pricing-accordion__toggle"
            (click)="togglePricingAccordion(plan.planId)"
            [attr.aria-expanded]="isPricingAccordionOpen(plan.planId)"
          >
            <span class="pricing-accordion__heading-wrap">
              <span class="pricing-accordion__heading-block">
                <span class="pricing-accordion__heading-line">
                  <span class="pricing-accordion__heading">{{ plan.sensorHeading }}</span>
                </span>
                <span class="pricing-accordion__subtext">{{ plan.sensorSubtext }}</span>
              </span>
            </span>
            <span class="pricing-accordion__meta">
              <span class="pricing-accordion__count">{{ plan.sensorCount }}</span>
              <mat-icon class="pricing-accordion__arrow">expand_more</mat-icon>
            </span>
          </button>

          <div class="pricing-accordion__body">
            <div class="pricing-accordion__body-inner">
              <div class="sensor-list">
                <div *ngFor="let sensor of plan.sensorItems" class="sensor-list__item">
                  <span class="sensor-text" [ngClass]="'sensor-text--' + sensor.category">{{ sensor.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #enterpriseSensorSummary>
          <div class="pricing-enterprise-summary">
            {{ plan.enterpriseSensorSummary }}
          </div>
        </ng-template>

        <div class="feature-list" [ngClass]="{ 'feature-list--enterprise': plan.enterprise }">
          <div class="feature-list__heading">{{ plan.featureHeading }}</div>
          <div *ngFor="let feature of plan.features" class="feature-list__item">
            <mat-icon class="feature-list__icon" aria-hidden="true">check_circle</mat-icon>
            <span>{{ feature }}</span>
          </div>
        </div>
      </article>
    </div>

  </div>
</div>
<div *ngIf="notRegistered === false">
   <div class="container userRegister">
    <img *ngIf="!isInIframe" src="../../../assets/images/logo.png" alt="logo" style="width: 36%" />
    <h4>Discover earth with us</h4>
    <p>Start Here to Solve the Hardest Problems</p>

    <form class="form-vertical" [formGroup]="registerForm" (ngSubmit)="onSubmit()">

      <div class="register-wrapper">
        <div class="form-group">
          <mat-label>First Name<span>*</span></mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Your first name" formControlName="fullName" ngForm=""
              (keypress)="utilsService.keyPressValidation($event)" (keydown)="Space($event)"
              [ngClass]="{ 'is-invalid': f.fullName.errors && f.fullName.touched }" (focus)="onFocusProject('fullName')" />
            <mat-error *ngIf="f.fullName.touched && f.fullName.errors" class="alert alert-danger">
              <mat-error *ngIf="f.fullName.errors.required"> Your First Name is required</mat-error>
              <mat-error *ngIf="!f.fullName.errors.required && f.fullName.hasError('specialChars')"> No special characters are allowed</mat-error>
              <mat-error *ngIf="f.fullName.hasError('minlength') && !f.fullName.hasError('specialChars')"> At least 3 characters long</mat-error>
              <mat-error *ngIf="f.fullName.hasError('maxlength') && !f.fullName.hasError('specialChars')"> Maximum 50 characters long</mat-error>
            </mat-error>
            <mat-icon matSuffix *ngIf="f.fullName.touched && !f.fullName.errors"><img
                src="../../../assets/images/done.svg"></mat-icon>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-label>Last Name<span>*</span></mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Your last name" formControlName="lastName" ngForm=""
              (keypress)="utilsService.keyPressValidation($event)" (keydown)="Space($event)"
              [ngClass]="{ 'is-invalid': f.lastName.errors && f.lastName.touched }" (focus)="onFocusProject('lastName')" />
            <mat-error *ngIf="f.lastName.touched && f.lastName.errors" class="alert alert-danger">
              <mat-error *ngIf="f.lastName.errors.required"> Your Last Name is required</mat-error>
              <mat-error *ngIf="f.lastName.hasError('maxlength') && !f.lastName.hasError('specialChars')"> Maximum 50 characters long</mat-error>
              <mat-error *ngIf="!f.lastName.errors.required && f.lastName.hasError('specialChars')"> No special characters are allowed</mat-error>
            </mat-error>
            <mat-icon matSuffix *ngIf="f.lastName.touched && !f.lastName.errors"><img
                src="../../../assets/images/done.svg"></mat-icon>
          </mat-form-field>
        </div>


        <div class="form-group">
          <mat-label>Display Name<span>*</span></mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Your display name" formControlName="displayName" ngForm=""
              [ngClass]="{ 'is-invalid': f.displayName.errors && f.displayName.touched }"
              (keypress)="utilsService.keyPressValidation($event)" (keydown)="Space($event)"  (focus)="onFocusProject('displayName')" />

            <mat-error *ngIf="f.displayName.touched && f.displayName.errors" class="alert alert-danger">
              <mat-error *ngIf="f.displayName.errors.required"> Display Name is required</mat-error>
              <mat-error *ngIf="f.displayName.hasError('minlength') && !f.displayName.hasError('specialChars')"> At least 3 characters long</mat-error>
              <mat-error *ngIf="f.displayName.hasError('maxlength') && !f.displayName.hasError('specialChars')"> Maximum 15 characters long</mat-error>
              <mat-error *ngIf="!f.displayName.errors.required && f.displayName.hasError('specialChars')"> No special characters are allowed</mat-error>
            </mat-error>
            <mat-icon matSuffix *ngIf="f.displayName.touched && !f.displayName.errors"><img
                src="../../../assets/images/done.svg"></mat-icon>
          </mat-form-field>
        </div>


        <div class="form-group">
          <mat-label>Email<span>*</span></mat-label>
          <mat-form-field appearance="outline">

            <input matInput type="text" placeholder="Your email" formControlName="email" ngForm=""
              (keypress)="keyPress($event)" (keydown)="Space($event)" (focus)="onFocusProject('email')"
              [ngClass]="{ 'is-invalid': f.email.errors && f.email.touched }" />
            <mat-error *ngIf="f.email.touched && f.email.errors" class="alert alert-danger">
              <mat-error *ngIf="f.email.errors.required">Please enter a valid email</mat-error>
              <mat-error *ngIf="f.email.errors.pattern"> Please use an official email address</mat-error>
            </mat-error>
            <div *ngIf="!notRegistered && submitted && !f.email.errors" class="alert-box"
              style="padding-top: 15px !important; margin-left: -11px;">
              {{warnMsg}}
            </div>
            <mat-icon matSuffix *ngIf="f.email.touched && !f.email.errors"><img
                src="../../../assets/images/done.svg"></mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div>
        <button mat-raised-button color="primary" [disabled]="registerForm.invalid" id="button">NEXT</button>
      </div>
       <div class="regist">
        <span>Already registered? <a (click)="onResetClick($event)" routerLink="/login">Sign In</a></span>
      </div>
       <div class="regist">
               <span>Want to change the plan?
                <a (click)="onResetClick($event)" style="cursor:'pointer'">Click here</a></span>
      </div>
    </form>
  </div>   


</div> 

<div *ngIf="notRegistered" class="notRegistered">
  <div class="container">
    <img *ngIf="!isInIframe" src="../../../assets/images/logo.png" alt="logo" style="width: 40%" />
    <h4>Sign Up</h4>
    <div class="mails">
      <p>
        Your Email: <span class="link">{{ registerForm.value.email.toLowerCase()
          }}</span>
      </p>
    </div>
    <div id="wrapper">
      <div class="scrollbar" id="style-4">
        <div class="force-overflow"></div>
        <form class="form-vertical" [formGroup]="signupform" (ngSubmit)="submitSignup()">

          <div>
            <label>Organisation Name<span>*</span></label>
            <input type="text" placeholder="Your organisation name" formControlName="companyName" class="form-control"
              [ngClass]="{ 'is-invalid': sign.companyName.errors && sign.companyName.touched }"
              (keydown)="Space($event)" id="company" style="box-shadow: none;	
              z-index: 0;" />
            <div *ngIf="sign.companyName.errors && sign.companyName.touched" class="alert alert-danger align">
              <div *ngIf="sign.companyName.errors.required"> Organisation name is required</div>
            </div>
          </div>

          <div>
            <label>Website<span>*</span></label>
            <input type="text" placeholder="Your website" formControlName="website" class="form-control"
              [ngClass]="{ 'is-invalid': sign.website.errors && sign.website.touched }"
              (keydown)="Space($event)" id="website" style="box-shadow: none;	
              z-index: 0;" (focus)="onFocusForm('website')" />
            <div *ngIf="sign.website.errors && sign.website.touched" class="alert alert-danger align">
              <div *ngIf="sign.website.errors.required"> Website is required</div>
              <div *ngIf="sign['website'].errors?.['pattern']">
                Please enter a valid website
              </div>
            </div>
          </div>

          <div>
            <mat-label>Organisation Type<span>*</span></mat-label>
            <mat-form-field appearance="outline" style="height: 40px;">
              <mat-select [disableOptionCentering]="true" panelClass="matopencountry" formControlName="organisationType"
                placeholder="Choose organisation type" [ngClass]="{ 'is-invalid': sign.organisationType.errors && sign.organisationType.touched }">
                <mat-option *ngFor="let type of organisationTypes" [value]="type">
                  {{type.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="sign.organisationType.errors && sign.organisationType.touched" class="alert alert-danger align">
              <div *ngIf="sign.organisationType.errors.required"> Organisation type is required</div>
            </div>
          </div>

          <div>
            <label>Department<span>*</span></label>
            <input type="text" placeholder="Your department" formControlName="department" class="form-control"
              [ngClass]="{ 'is-invalid': sign.department.errors && sign.department.touched }"
              (keydown)="Space($event)" style="box-shadow: none;	
              z-index: 0;" />
            <div *ngIf="sign.department.errors && sign.department.touched" class="alert alert-danger align">
              <div *ngIf="sign.department.errors.required"> Department is required</div>
            </div>
          </div>

          <div>
            <label>Role/Position<span>*</span></label>
            <input type="text" placeholder="Your role/position" formControlName="role" class="form-control"
              [ngClass]="{ 'is-invalid': sign.role.errors && sign.role.touched }"
              (keydown)="Space($event)" style="box-shadow: none;	
              z-index: 0;" />
            <div *ngIf="sign.role.errors && sign.role.touched" class="alert alert-danger align">
              <div *ngIf="sign.role.errors.required"> Role/Position is required</div>
            </div>
          </div>

          <div>
            <label>Phone Number<span>*</span></label>
            <input type="number" placeholder="Your phone number" formControlName="phonenumber" class="form-control"
              (keypress)="keyPressPhone($event)"
              [ngClass]="{ 'is-invalid': sign.phonenumber.errors && sign.phonenumber.touched }" style="box-shadow: none;	
              z-index: 0;"  (focus)="onFocusForm('phonenumber')" />
            <div *ngIf="sign.phonenumber.errors && sign.phonenumber.touched" class="alert alert-danger align">
              <div *ngIf="sign.phonenumber.errors.required"> Please enter a valid phone number</div>
              <div *ngIf="sign.phonenumber.hasError('maxlength')"> Must be no more than 15 characters</div>
            </div>
          </div>
          <div>
            <label>Password<span>*</span></label>
            <input [type]="showPassword ? 'password' : 'text'" placeholder="Your password" formControlName="password"
              id="password" type="password" class="form-control"
              [ngClass]="{ 'input-error': sign['password'].touched && sign['password'].invalid}"
              (keydown)="Space($event)" required (focus)="onFocusForm('password')" />
            <mat-icon matSuffix (click)="togglePasswordVisibility()">
              {{ showPassword ? "visibility_off" : "visibility" }}
            </mat-icon>
            <div *ngIf="sign['password'].touched && sign['password'].invalid" class="alert alert-danger align">
              <div *ngIf="sign['password'].errors?.['required']">
                Password is required
              </div>

              <div class="passerror"
                *ngIf="sign['password'].errors?.['minlength'] || sign['password'].errors?.['pattern']">
                Must contain <span *ngIf="sign['password'].errors?.['minlength']"> mimimum of 8 characters </span>

                <span *ngIf="sign['password'].errors?.['pattern']"> with at least one capital letter and a special
                  character </span>
              </div>

            </div>
          </div>

          <div>
            <label>Confirm Password<span>*</span></label>
            <input [type]="confirmshowPassword ? 'password' : 'text'" placeholder="Confirm your password"
              formControlName="confirm_password" id="confirm_password" type="password" class="form-control"
              (keydown)="Space($event)" (focus)="onFocusForm('confirm_password')"
              [ngClass]="{ 'input-error': sign.confirm_password.errors && sign.confirm_password.touched }" />
            <mat-icon matSuffix (click)="toggleconfirmPasswordVisibility()">
              {{ confirmshowPassword ? "visibility_off" : "visibility" }}
            </mat-icon>
            <div *ngIf="
                sign['confirm_password'].touched &&
                sign['confirm_password'].invalid
              " class="alert alert-danger align">
              <div *ngIf="sign['confirm_password'].errors?.['required']">
                Password is required.
              </div>
              <div *ngIf="sign['confirm_password'].errors?.['confirmedValidator']">
                The passwords must be the same.
              </div>
            </div>
          </div>

          <div class="address">
            <label>Address<span>*</span></label>
            <div style="margin-bottom: 15px;">
              <input placeholder="Address line 1" formControlName="address1" type="text" class="form-control"
                [ngClass]="{ 'is-invalid': sign.address1.errors && sign.address1.touched }" (keydown)="Space($event)"
                style="box-shadow: none;	
              z-index: 0;" />
              <div *ngIf="sign.address1.errors && sign.address1.touched" class="alert alert-danger align">
                <div *ngIf="sign.address1.errors.required"> Address is required</div>
              </div>
            </div>
            <input placeholder="Address line 2" formControlName="address2" type="text" class="form-control"
              (keydown)="Space($event)" />
          </div>
          <div>
            <label>City<span>*</span></label>
            <input placeholder="City" formControlName="city" type="text" class="form-control"
              [ngClass]="{ 'is-invalid': sign.city.errors && sign.city.touched }" (keydown)="Space($event)" style="box-shadow: none;	
              z-index: 0;" />
            <div *ngIf="sign.city.errors && sign.city.touched" class="alert alert-danger align">
              <div *ngIf="sign.city.errors.required"> City is required</div>
            </div>

          </div>
          <div>
            <label>Zip Code</label>
            <input placeholder="Zip Code" formControlName="zip_code" type="number" class="form-control" />


          </div>
          <div>
            <mat-label>Country<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <mat-select [disableOptionCentering]="true" panelClass="matopencountry" formControlName="country"
                placeholder="Choose country" [ngClass]="{ 'is-invalid': sign.country.errors && sign.country.touched }">
                <mat-option *ngFor="let country of countries" [value]="country">
                  {{country.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="sign.country.errors && sign.country.touched" style="font-weight: 600; font-size: 10px; color: red;">
                <mat-error *ngIf="sign.country.errors.required"> Country is required</mat-error>
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="upload">
            <label>Upload Profile Picture</label>
            <input class="form-control" [placeholder]=this.userPhotoFile.name type="text" readonly />
          </div>
          <div>
            <label *ngIf="!upload">Upload Profile Picture</label>
            <div class="profilepicture-update" *ngIf="!upload">
              <img src="../../../assets/images/upload.svg" alt="" style="width: 15%" />
              <h5>Select a file or drag and drop here</h5>
              <span>File size maximum 20kb with JPEG format</span>

              <div class="btns">
                <label for="imageUpload" class="btn">Upload</label>
                <input type="file" id="imageUpload" accept="image/*" formControlName="photo" style="display: none"
                  (change)="onFileSelected($event)" #imgInputs />

                <span *ngIf="oversize" style="color: red; text-align: left">File size must be less than 20 Kb</span>
                <span *ngIf="imageType" style="color: red; text-align: left">
                  Selected file is not an allowed image type
                </span>
              </div>

            </div>

            <!-- <div style="padding-bottom: 15px;" class="radio-items">
              <mat-radio-button 
              [checked]="selectedOption === 'withDeposit'" 
              (click)="acceptSubscription('withDeposit')"
              class="small-radio-button">
              Access platform with deposit.
              <img 
                style="margin-left: 5px;margin-top: -4px;" width="15px" [src]="tooltipImagePath"
                matTooltip="The full access is based on a minimum deposit of U$5000 as credit, which will need to be paid after the registration is confirmed." 
              />
            </mat-radio-button>

          
            <mat-radio-button 
              [checked]="selectedOption === 'withoutDeposit'" 
              (click)="acceptSubscription('withoutDeposit')"
              class="small-radio-button">
              Access platform without deposit.
              <img 
                style="margin-left: 5px;margin-top: -4px;" width="15px;" [src]="tooltipImagePath"
                matTooltip="Access without deposit is limited to one or more sensors and functionality." 
              />
            </mat-radio-button>
            </div> -->
              <div class="terms" *ngIf="selectedPlan === '2' || selectedPlan === '3' "
            style="padding-bottom:'10px';">
              <span>
                If you need a quote, <b (click)="requestQuotation()">Click here</b>
              </span>
            </div>

            <div class="terms" id="term" style="padding-bottom: 17px;">
              <mat-checkbox [checked]="check" (click)="OpenPopup($event)">
                <span>Accept the
                  <b >Terms of Use</b></span>
              </mat-checkbox>
            </div>

            <div> 
              <button mat-raised-button color="primary" [disabled]="signupform.invalid || !check || register"
                id="buttons">REGISTER</button>           
            </div>
           <div class="regist-inner">
              <span>Already registered?     
                <a (click)="onResetClick($event)" routerLink="/login">Sign In</a></span>
            </div>
             <div class="reset-inner">
               <span>Want to change the plan?
                <a (click)="onResetClick($event)">Click here</a></span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #tooltipTemplate let-data>
  <div class="custom-tooltip-box">
    <app-custom-tooltip [metadata]="data.accessDetails" product="planUpgrade"></app-custom-tooltip>
  </div>
</ng-template>